// @flow
import React from 'react'
import Link from "gatsby-link"
import injectSheet from "react-jss"
import classNames from 'classnames'

import NavBar from '../components/Navbar'

import {styles} from './Styles/HeroHeader.Style'

import scrollIndicator from '../images/scroll-indicator.svg'
import productCard1 from '../images/Product-card-01.png'
import productCard2 from '../images/Product-card-02.png'
import productCard3 from '../images/Product-card-03.png'
import productCard4 from '../images/Product-card-04.png'
import productCard5 from '../images/Product-card-05.png'
import productCard6 from '../images/Product-card-06.png'

type Props = {
  classes: { [string]: string }
}

class HearHeader extends React.Component {
  props: Props

  animateProduct = () => {
    const img1 = document.getElementById('img1')
    const img2 = document.getElementById('img2')
    const img3 = document.getElementById('img3')
    const img4 = document.getElementById('img4')
    const img5 = document.getElementById('img5')
    const img6 = document.getElementById('img6')


  }

  render () {
    const {classes} = this.props

    return (
      <div className={classNames(classes.container, 'wrap')}>

        <NavBar/>

        <div className='container wrap'>
          <div className='row'>
            <div className={classNames(classes.info, 'col-xs-12 col-sm-6')}>

              <div className={classes.taglines}>
                <h1 className={classes.title}>Where your next collection starts</h1>
                <p className={classes.subTitle}>
                  A platform for jewelry designers to prepare their new collection for production.
                </p>
              </div>

              <button className={classes.button + ' drift-open-chat'}
                onClick={{/* TODO for JBR: add action to open the chat */}} >
                Request access
              </button>

              <div className={classes.scrollNote}>
                <img src={scrollIndicator} alt='Scroll down' width='26' height='40' />
                <p>Scroll down to learn more</p>
              </div>

            </div>
            <div className={classNames(classes.xsHide, 'col-sm-6')}>
              <img className={classes.prodImg} src={productCard1} alt='product' height='90' />
              <img className={classes.prodImg} src={productCard2} alt='product' height='90' />
              <img className={classNames(classes.prodImg, classes.opacity90)} src={productCard3} alt='product' height='90' />
              <img className={classNames(classes.prodImg, classes.opacity80)} src={productCard4} alt='product' height='90' />
              <img className={classNames(classes.prodImg, classes.opacity50)} src={productCard5} alt='product' height='90' />
              <img className={classNames(classes.prodImg, classes.opacity30)} src={productCard6} alt='product' height='90' />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default injectSheet(styles)(HearHeader)



// WEBPACK FOOTER //
// ./src/layouts/HeroHeader.jsx